import { otpHost } from 'config/env.conf';
export const MsgCategories = [{
    id: 1,
    name: '编审'
}, {
    id: 2,
    name: '促销'
}, {
    id: 3,
    name: '其它'
}];
let shenSuRefundList = { stateName: 'ticketOrderRefund' };

export const OtherMsgTypesMap = {
    18: { stateName: 'ticketselfPromotionList', paramName: 'activityId', params: { status: 0 } },
    34: { stateName: 'gtyselfPromotionList', paramName: 'activityId', params: { status: 0 } },
    35: { stateName: 'jiujingselfPromotionList', paramName: 'activityId', params: { status: 0 } },
    39: { stateName: 'gtysummary', paramName: 'id', params: {} },
    40: { stateName: 'jiujingsummary', paramName: 'id', params: {} },
    41: { stateName: 'ticketflowInvestList', paramName: 'id', params: { status: 0, slotStatus: 0 } },
    42: { stateName: 'ticketflowInvestList', paramName: 'id', params: { status: 0, slotStatus: 2 } },
    43: { stateName: 'ticketflowInvestList', paramName: 'id', params: { status: 0, slotStatus: 5 } },
    888: { stateName: 'ticketselfPromotionList', paramName: 'id', params: {} },
    50: shenSuRefundList
};

export const TICKETORDERCODE = 1;

export const TICKETORDERTYPE = 888;
let hasHtmlExt = otpHost.includes('.html');

let editCertificate = { stateName: 'ticketeditCertificate', paramName: 'id', urlPattern: `${otpHost}${hasHtmlExt?'':'/'}#/ticket/product/edit-certificate/$bizKey` };
let tickerList = { stateName: 'ticketlistProduct', paramName: 'dealId' };
let jiujingEditProduct = { stateName: 'jiujing-editProduct', paramName: 'id', paramsExt: { tab: 4 }, noblank: true, urlPattern: `${otpHost}${hasHtmlExt?'':'/'}#/jiujing/product/edit/$bizKey?tab=4` };
let verifyList = { stateName: 'verify', urlPattern: '#/notification/verify?categoryId=65' };
export const LandingPageMap = { 50: shenSuRefundList, 2: editCertificate, 5: editCertificate, 7: tickerList, 10: tickerList, 11: tickerList, 65: jiujingEditProduct, '65taa': verifyList };

export const businessLines = [{
    name: '门票',
    value: 'ticket',
    bizLineId: 2
}, {
    name: '跟团游',
    value: 'packageTour',
    bizLineId: 3
}, {
    name: '景酒',
    value: 'sceneHotel',
    bizLineId: 4
}, {
    name: '机酒',
    value: 'airlineTicket',
    bizLineId: 6
}, {
    name: '旅游用车',
    value: 'carTicket',
    bizLineId: 7
}];


// WEBPACK FOOTER //
// ./src/data/notification.js